export var BindingTypes;
(function (BindingTypes) {
  BindingTypes["MODULE"] = "module";
  BindingTypes["ALL"] = "all";
  BindingTypes["EXPOSE"] = "expose";
  BindingTypes["CLICK"] = "click";
})(BindingTypes || (BindingTypes = {}));
;
/**
 * @description 上报事件类型
 */
export var EventType;
(function (EventType) {
  /**
   * 点击
   */
  EventType["CLICK"] = "click";
  /**
   * 曝光
   */
  EventType["EXPOSE"] = "expose";
})(EventType || (EventType = {}));
/**
 * @description 上报对象类型
 */
export var ReportElementType;
(function (ReportElementType) {
  /**
   * 实时pv，为避免pv损失，在初始化时进行上报的pv
   */
  ReportElementType[ReportElementType["REALTIME_PAGE"] = -2] = "REALTIME_PAGE";
  /**
   * pv
   */
  ReportElementType[ReportElementType["PAGE"] = 0] = "PAGE";
  /**
   * 模块
   */
  ReportElementType[ReportElementType["MODULE"] = 1] = "MODULE";
  /**
   * 封面
   */
  ReportElementType[ReportElementType["POSTER"] = 2] = "POSTER";
  /**
   * 其它子节点
   */
  ReportElementType[ReportElementType["ELEMENT"] = 3] = "ELEMENT";
  /**
   * 按纽
   */
  ReportElementType[ReportElementType["BUTTON"] = 4] = "BUTTON";
  /**
   * 推广位
   */
  ReportElementType[ReportElementType["ADV"] = 5] = "ADV";
})(ReportElementType || (ReportElementType = {}));